/* Developed by: Philip C. Diaz
   Experience: Javascript Developer | Senior Frontend Developer | ReactJS Developer
   Email: diazphi@gmail.com
   License: Forever Free, you are freely to improve and modify.
*/      
"use strict";
window.theme = window.theme || {}
theme.collectionSearchEngine = function() {

    function collectionSearchEngine() {

        this.selector = {
            search: document.querySelector('.breadcrumb_pr_wrap input.quick-search-input'),
            result: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-list-result > ul'),
            alphabet: document.querySelectorAll('.breadcrumb_pr_wrap .collection-quick-search-sort-by > ul > li'),
            filter: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-keyword > h3 > strong'),
            az: document.querySelectorAll('.breadcrumb_pr_wrap .collection-quick-search-sort-by > ul > li > button'),
            breadhistory: document.querySelector('.breadcrumb_pr_wrap .bread-history-cookie'),
            expandable: document.querySelector('.breadcrumb_pr_wrap button.expand-down')
           
        }
        this.container = {
            collections: document.querySelector('.breadcrumb_pr_wrap .js-collection-data-list'),
            search_result: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-list-result'),
            search_close: document.querySelector('.breadcrumb_pr_wrap .search-close'),
            container: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search'),
            sortby: document.querySelector('.breadcrumb_pr_wrap .collection-quick-search-sort-by > ul')
        }
        this.databank = [];

        this.load();

    }

    collectionSearchEngine.prototype.load = function() {
        var _ = this; 
        let array_collections_title = JSON.parse(_.container.collections.getAttribute('data-array-collections-title'));
        let array_collections_url = JSON.parse(_.container.collections.getAttribute('data-array-collections-url'));
        let array_collections_count = JSON.parse(_.container.collections.getAttribute('data-array-collections-count'));
        var JSONItems = '{"collections":[{"title":"'+array_collections_title[0]+'","url":"'+array_collections_url[0]+'","count":"'+array_collections_count[0]+'"}]}';
        _.databank = JSON.parse(JSONItems);

                if(array_collections_title.length>1) {
                    array_collections_title.forEach((element,index) => {
                        if(index>0) {
                            _.databank['collections'].push({"title":`${array_collections_title[index]}`,"url":`${array_collections_url[index]}`,"count":`${array_collections_count[index]}`});
                        }                                        
                    });                                   
                }    
        _.selector.search.addEventListener('keyup', (event) => {
            _.search();
            if (event.key === "Escape") {
                _.closeresult();
            }
        });
        _.selector.alphabet.forEach(element => {
            element.addEventListener('click', (event) => {
               [].forEach.call(_.selector.az, (btn) => {
                    btn.classList.remove('active');
                })
                event.target.closest('button').classList.add('active');
                _.sortby(event);
            });
        })
        _.container.search_close.addEventListener('click', () => {
           _.closeresult();
       })
       if(_.selector.breadhistory) {
           _.selector.breadhistory.textContent = _.getcookies('breedhistorytitle');
           if(_.getcookies('breedhistoryurl') !== 'empty') {
           _.selector.breadhistory.href = _.getcookies('breedhistoryurl');
           } else {
            _.selector.breadhistory.href = '#';
           }
       }
       _.selector.expandable.addEventListener('click', (event) => {
           if(_.container.sortby.classList.contains('active')) {
              _.container.sortby.classList.remove('active');
              event.target.closest('button').classList.remove('expanded');
           } else {
              _.container.sortby.classList.add('active');
              event.target.closest('button').classList.add('expanded');
           }           
       })
    }
    
    collectionSearchEngine.prototype.search = function() {
            var _ = this;
            let result_container = _.selector.result;
            let count_items = 0;
            if(_.databank['collections'].length>0) {
               result_container.innerHTML = '';
               _.container.search_result.classList.add('active');
               _.container.search_close.classList.add('active');
                _.databank['collections'].forEach(value => {
                    var title = value.title.toLowerCase();
                    var keyword = _.selector.search.value.toLowerCase();
                    if(title.startsWith(keyword)) {
                        var result_list = document.createElement('li');
                        var result_link = document.createElement('button');
                        var result_count = document.createElement('span');
                        result_link.setAttribute('type','button');
                        result_link.setAttribute('data-url',value.url);
                        result_link.textContent = value.title;
                        result_count.textContent = ' ('+value.count+')';
                        result_link.append(result_count)
                        result_list.append(result_link);
                        result_container.append(result_list);
                        count_items++;
                    }                   
                })
                let listbreed = document.querySelectorAll('.collection-quick-search-list-result > ul > li > button');
                listbreed.forEach(element => {
                    element.addEventListener('click', (event) => {
                        _.setcookies(event.target.closest('button').textContent,event.target.closest('button').getAttribute('data-url'));
                    });
                })
                _.selector.filter.textContent = 'keyword start with "'+_.selector.search.value+'" found '+count_items+' of '+_.databank['collections'].length+ ' collections';
            } else {
                result_container.innerHTML = '';
                _.container.search_result.classList.remove('active');
                _.container.search_close.classList.add('remove');
            }
    }

    collectionSearchEngine.prototype.sortby = function(event) {
        var _ = this;
        let result_container = _.selector.result;
        let count_items = 0;
        if(_.databank['collections'].length>0) {
           result_container.innerHTML = '';
           _.container.search_result.classList.add('active');
           _.container.search_close.classList.add('active');
            _.databank['collections'].forEach(value => {
                var title = value.title.toLowerCase();
                var keyword = event.target.closest('button').textContent.toLowerCase();
                if(title.startsWith(keyword)) {
                    var result_list = document.createElement('li');
                    var result_link = document.createElement('button');
                    var result_count = document.createElement('span');
                    result_link.setAttribute('type','button');
                    result_link.setAttribute('data-url',value.url);
                    result_link.textContent = value.title;
                    result_count.textContent = ' ('+value.count+')';
                    result_link.append(result_count)
                    result_list.append(result_link);
                    result_container.append(result_list);
                    count_items++;
                } else if (keyword === 'all:') {
                    var result_list = document.createElement('li');
                    var result_link = document.createElement('button');
                    var result_count = document.createElement('span');
                    result_link.setAttribute('type','button');
                    result_link.setAttribute('data-url',value.url);
                    result_link.textContent = value.title;
                    result_count.textContent = ' ('+value.count+')';
                    result_link.append(result_count)
                    result_list.append(result_link);
                    result_container.append(result_list);
                    count_items++;
                }                  
            })
            let listbreed = document.querySelectorAll('.collection-quick-search-list-result > ul > li > button');
            listbreed.forEach(element => {
                element.addEventListener('click', (event) => {
                    _.setcookies(event.target.closest('button').textContent,event.target.closest('button').getAttribute('data-url'));
                });
            })
            _.selector.filter.textContent = 'filter by first letter "'+event.target.closest('button').textContent+'" found '+count_items+' of '+_.databank['collections'].length+ ' collections';
        } else {
            _.selector.result.innerHTML = '';
            _.container.search_result.classList.remove('active');
            _.container.search_close.classList.remove('active');
        }
    }
    collectionSearchEngine.prototype.closeresult = function() {
        var _ = this;
        _.selector.result.innerHTML = '';
        _.container.search_result.classList.remove('active');
        _.container.search_close.classList.remove('active');
    }
    collectionSearchEngine.prototype.setcookies = function(cvalue,clink) {
            const d = new Date();
            d.setTime(d.getTime() + (30*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = 'breedhistorytitle' + "=" + cvalue + ";" + expires + ";path=/";
            document.cookie = 'breedhistoryurl' + "=" + clink + ";" + expires + ";path=/";
            window.location.href = clink;
    }
    collectionSearchEngine.prototype.getcookies = function(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "empty";
}

  theme.collectionSearchEngine = new collectionSearchEngine;

}

theme.collectionSearchEngine();